import { LinkedRecord } from "./LinkedRecord";

export type LinkedRecordViewModel = {
  id: string;
  linkedEntityId: string;
  linkedEntityType: number;
  linkedEntityTitle: string;
  linkType: number;
  linkNote: string;
  linkMeta: string;
  createdByUpn: string;
  createdByDisplayName: string;
  createdDate: string;
  linkedEntityRelationship: "DESTINATION" | "SOURCE";
};

export const toViewModel = (entityId: string, linkedRecord: LinkedRecord) => {
  const entityProps =
    linkedRecord.sourceId === entityId
      ? {
          linkedEntityId: linkedRecord.destinationId,
          linkedEntityType: linkedRecord.destinationType,
          linkedEntityTitle: linkedRecord.destinationTitle,
          linkedEntityRelationship: <"DESTINATION">"DESTINATION",
        }
      : {
          linkedEntityId: linkedRecord.sourceId,
          linkedEntityType: linkedRecord.sourceType,
          linkedEntityTitle: linkedRecord.sourceTitle,
          linkedEntityRelationship: <"SOURCE">"SOURCE",
        };

  return {
    ...linkedRecord,
    ...entityProps,
  } as LinkedRecordViewModel;
};
